import { Grid } from '@mui/material';
import React from 'react';
import ControlledInputText from 'components/common/forms/controlled_input_text';
import ControlledInputPassword from 'components/common/forms/controlled_input_password';
import ControlledCheckbox from 'components/common/forms/controlled_checkbox';
import { useTranslation } from 'react-i18next';
import { buildLegalLink } from 'utilities/links';
import { useFormContext } from 'react-hook-form';
import {
  BIRTHDATE_REGEX,
  SSN_REGEX,
  EXPERIAN_PATTERNS,
} from 'constants/patterns';
import { US_STATE_MAPPINGS } from 'constants/mappings';

const Fields = (props) => {
  const { applicationData, disabled } = props;
  const { control } = useFormContext();
  const { t } = useTranslation();

  return (
    <>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.firstName')}
          name="personal_first_name"
          control={control}
          rules={{
            required: true,
            pattern: EXPERIAN_PATTERNS.name,
          }}
          disabled
          defaultValue={applicationData.personal_first_name || ''}
          autocomplete="given-name"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.lastName')}
          name="personal_last_name"
          control={control}
          rules={{
            required: true,
            pattern: EXPERIAN_PATTERNS.name,
          }}
          disabled
          defaultValue={applicationData.personal_last_name || ''}
          autocomplete="family-name"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledInputText
          label={t('checkout.label.dateOfBirth')}
          name="personal_birthdate"
          control={control}
          disabled={disabled}
          rules={{
            required: true,
            pattern: BIRTHDATE_REGEX,
          }}
          defaultValue={applicationData.personal_birthdate || ''}
          placeholder="YYYY-MM-DD"
        />
      </Grid>
      <Grid item xs={12} md={6}>
        <ControlledInputPassword
          label={t('checkout.label.socialSecurityNumber')}
          name="personal_ssn"
          control={control}
          disabled={disabled}
          rules={{
            required: true,
            pattern: SSN_REGEX,
          }}
          placeholder="000-00-0000"
        />
      </Grid>
      <Grid item xs={12} md={8}>
        <ControlledInputText
          label={t('checkout.label.addressLine1')}
          name="personal_street_1"
          control={control}
          disabled={disabled}
          rules={{
            required: true,
            pattern: EXPERIAN_PATTERNS.street,
          }}
          defaultValue={applicationData.personal_street_1 || ''}
          autocomplete="address-line1"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label={t('checkout.label.addressLine2')}
          name="personal_street_2"
          defaultValue={applicationData.personal_street_2 || ''}
          control={control}
          rules={{
            pattern: EXPERIAN_PATTERNS.street,
          }}
          disabled={disabled}
          autocomplete="address-line2"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label={t('checkout.label.city')}
          name="personal_city"
          defaultValue={applicationData.personal_city || ''}
          control={control}
          disabled={disabled}
          rules={{
            pattern: EXPERIAN_PATTERNS.city,
            required: true,
          }}
          autocomplete="address-level2"
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label={t('checkout.label.state')}
          name="personal_state_province"
          disabled={disabled}
          defaultValue={applicationData.personal_state_province || ''}
          control={control}
          maxlength={2}
          rules={{
            required: true,
            maxLength: 2,
            pattern: new RegExp(
              `^(${Object.keys(US_STATE_MAPPINGS).join('|')})$`,
            ),
          }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <ControlledInputText
          label={t('checkout.label.postalCode')}
          name="personal_postal_code"
          disabled={disabled}
          defaultValue={applicationData.personal_postal_code || ''}
          control={control}
          rules={{
            required: true,
          }}
        />
      </Grid>
      <Grid item xs={12} md={12} mb={2}>
        <ControlledCheckbox
          name="accepted_legal_agreements"
          control={control}
          disabled={disabled}
          label={
            <div
              dangerouslySetInnerHTML={{
                __html: t('checkout.financeApp.legal_agreement_html', {
                  privacyLink: buildLegalLink('/privacy'),
                  esignLink: buildLegalLink('/sign'),
                  creditLink: buildLegalLink('/shop-credit-authorization'),
                }),
              }}
            />
          }
          defaultValue={applicationData.accepted_legal_agreements || false}
          rules={{ required: true }}
        />
      </Grid>
    </>
  );
};

export default Fields;
